import {
    Box,
    Checkbox,
    FormControlLabel,
    SxProps,
    Theme,
    Typography,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

const DataCheckbox = ({
    fieldName,
    value,
    onChange,
    labelStyle,
    containerStyle,
}: {
    fieldName: string
    value: boolean
    onChange: () => void
    labelStyle?: SxProps<Theme>
    containerStyle?: SxProps<Theme>
}) => {
    const { t: translate } = useTranslation()

    const defaultLabelStyle = {
        color: 'greyFontColor',
        typography: 'text1',
        lineHeight: '19px',
    }

    const containerBasicStyle = {
        display: 'flex',
        alignItems: 'center',
        mt: '8px',
        height: '28px',
    }

    return (
        <Box sx={{ ...containerBasicStyle, ...containerStyle }}>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={value}
                        onChange={onChange}
                        name={fieldName}
                        color="primary"
                    />
                }
                label={
                    <Typography sx={{ ...defaultLabelStyle, ...labelStyle }}>
                        {translate(fieldName)}
                    </Typography>
                }
                sx={{ marginRight: '16px' }}
            />
        </Box>
    )
}

export { DataCheckbox }
